import React from 'react';
import ModuleShell from '@/components/layout/ModuleShell';
import KnowledgePacksPage from '@/pages/KnowledgePacksPage';
import AfcaTaggerPage from '@/pages/AfcaTaggerPage';
import SourceWatcherPage from '@/pages/SourceWatcherPage';

export default function KnowledgeModule() {
  const tabs = [
    { id: 'packs', label: 'Knowledge Packs', content: <KnowledgePacksPage /> },
    { id: 'afca', label: 'AFCA Tagger (Dean)', content: <AfcaTaggerPage /> },
    { id: 'sources', label: 'Source Watcher', content: <SourceWatcherPage /> },
  ];
  return (
    <ModuleShell
      title="Knowledge"
      subtitle="Versioned class knowledge packs — every entry carries source, vintage and citation"
      tabs={tabs}
    />
  );
}
